import { isDefined } from '@hsp/utilities';

import { ISort } from 'types/api/common';

export const getSorts = (value: string | undefined): ISort[] => {
  if (!isDefined(value)) {
    return [];
  }

  return value
    .split(',')
    .map((value) => value.trim())
    .map((sort) => {
      const [field, direction] = sort.split(' ');

      return {
        direction,
        field,
      } as ISort;
    });
};

export const getSortString = (value: string | ISort | ISort[] | undefined): string | undefined => {
  if (!isDefined(value)) {
    return;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (!Array.isArray(value)) {
    value = [value];
  }

  return value.map(({ direction, field }) => `${field} ${direction ?? 'asc'}`).join(',');
};
